// File: oneportal-shell/src/api/shopifyQueries.ts
// Custom Shopify GraphQL queries with metafields
// Updated to match production Shopify schema

/**
 * Product query with comprehensive metafields for product, SKU, and collection levels
 * This query fetches ALL metafields from production Shopify store
 */
export const PRODUCT_WITH_METAFIELDS_QUERY = `
query ProductWithMetafields($handle: String!) {
  product(handle: $handle) {
    id
    title
    description
    descriptionHtml
    handle
    productType
    tags
    collections(first: 20) {
      edges {
        node {
          title
          description
          handle
          code: metafield(namespace: "collection", key: "code") {
            value
            type
          }
          parentCode: metafield(namespace: "collection", key: "parent_code") {
            value
            type
          }
          metaDescription: metafield(namespace: "collection", key: "meta_description") {
            value
            type
          }
          metaTitle: metafield(namespace: "collection", key: "meta_title") {
            value
            type
          }
          ogTitle: metafield(namespace: "collection", key: "og_title") {
            value
            type
          }
          ogDescription: metafield(namespace: "collection", key: "og_description") {
            value
            type
          }
          filters: metafield(namespace: "collection", key: "filters") {
            value
            type
          }
          plpText: metafield(namespace: "collection", key: "plp_text") {
            value
            type
          }
        }
      }
    }

    seo {
      title
      description
    }
    featuredImage {
      url
      altText
      width
      height
    }
    images(first: 20) {
      edges {
        node {
          url
          altText
          width
          height
        }
      }
    }
    availableForSale
    publishedAt
    updatedAt

    variants(first: 10) {
      edges {
        node {
          id
          title
          price {
            amount
            currencyCode
          }
          sku
          availableForSale
          image{
            url
            altText
            width
            height
          }

          # New SKU Metafields  

            skuShortDescription: metafield(namespace: "sku", key: "sku_short_description") {
            value
            type
            }
            skuSpecs: metafield(namespace: "sku", key: "sku_specs") {
            value
            type
            }
            channelDisplayCategory: metafield(namespace: "sku", key: "channel_display_category") {
            value
            type
            }
            skuTitle: metafield(namespace: "sku", key: "sku_title") {
            value
            type
            }
            productNumber: metafield(namespace: "sku", key: "product_number") {
            value
            type
            }
            bundle: metafield(namespace: "sku", key: "bundle") {
            value
            type
            }
            skuNumber: metafield(namespace: "sku", key: "sku_number") {
            value
            type
            }
            newSkuIndicator: metafield(namespace: "sku", key: "new_sku_indicator") {
            value
            type
            }
            gettingStarted: metafield(namespace: "sku", key: "getting_started") {
            value
            type
            }
            planSequence: metafield(namespace: "sku", key: "plan_sequence") {
            value
            type
            }
            planFamily: metafield(namespace: "sku", key: "plan_family") {
            value
            type
            }
            seoMetaTitle: metafield(namespace: "sku", key: "seo_meta_title") {
            value
            type
            }
            seoOgTitle: metafield(namespace: "sku", key: "seo_og_title") {
            value
            type
            }
            seoOgDescription: metafield(namespace: "sku", key: "seo_og_description") {
            value
            type
            }
            seoMetaDescription: metafield(namespace: "sku", key: "seo_meta_description") {
            value
            type
            }
            skuToSkuLinkQuantity: metafield(namespace: "sku", key: "sku_to_sku_link_quantity") {
            value
            type
            }
            skuToSkuLinkTypeCode: metafield(namespace: "sku", key: "sku_to_sku_link_type_code") {
            value
            type
            }
            skuToSkuLinkRelatedSkuNumber: metafield(namespace: "sku", key: "sku_to_sku_link_related_sku_number") {
            value
            type
            }
            skuToSkuLinkSkuToSkuSequence: metafield(namespace: "sku", key: "sku_to_sku_link_sku_to_sku_sequence") {
            value
            type
            }
            websiteSkuStatus: metafield(namespace: "sku", key: "website_sku_status") {
            value
            type
            }
            soldByRetailer: metafield(namespace: "sku", key: "sold_by_retailer") {
            value
            type
            }
            proInstall: metafield(namespace: "sku", key: "pro_install") {
            value
            type
            }
            soldDirectToConsumer: metafield(namespace: "sku", key: "sold_direct_to_consumer") {
            value
            type
            }
            bestSellerBadge: metafield(namespace: "sku", key: "best_seller_badge") {
            value
            type
            }
            webPreview: metafield(namespace: "sku", key: "web_preview") {
            value
            type
            }
          
          	recurringPrice: metafield(namespace: "sku", key: "recurring_price") {
            value
            type
            }
          	defaultNode: metafield(namespace: "sku", key: "default_node") {
            value
            type
            }
         		brandingLogo: metafield(namespace: "sku", key: "branding_logo") {
              reference {
                ... on MediaImage {
                  id
                  image {
                    url
                    width
                    height
                    altText
                  }
                }
              }
            }
          	defaultCategory: metafield(namespace: "sku", key: "default_category") {
              value
              type
              reference{
                ... on Collection {
                  title
                  description
                  handle
                  code: metafield(namespace: "collection", key: "code") {
                    value
                    type
                  }
                  parentCode: metafield(namespace: "collection", key: "parent_code") {
                    value
                    type
                  }
                  metaDescription: metafield(namespace: "collection", key: "meta_description") {
                    value
                    type
                  }
                  metaTitle: metafield(namespace: "collection", key: "meta_title") {
                    value
                    type
                  }
                  ogTitle: metafield(namespace: "collection", key: "og_title") {
                    value
                    type
                  }
                  ogDescription: metafield(namespace: "collection", key: "og_description") {
                    value
                    type
                  }
                  filters: metafield(namespace: "collection", key: "filters") {
                    value
                    type
                  }
                  plpText: metafield(namespace: "collection", key: "plp_text") {
                    value
                    type
                  }

                }
              }
            }
            

            # Old SKU Metafields

            serviceTerm : metafield(namespace: "custom", key: "service_term") {
            value
            type
            }
            subscriptionBillingId : metafield(namespace: "custom", key: "subscription_billing_id") {
            value
            type
            }
            enableQuantityModification : metafield(namespace: "custom", key: "enable_quantity_modification") {
            value
            type
            }
            documents : metafield(namespace: "custom", key: "documents") {
            value
            type
            }
            isPromotionEffective : metafield(namespace: "custom", key: "ispromotioneffective") {
            value
            type
            }
            previewProduct : metafield(namespace: "custom", key: "preview_product") {
            value
            type
            }
            subscriptionTermId : metafield(namespace: "custom", key: "subscription_term_id") {
            value
            type
            }
            imageAssets : metafield(namespace: "custom", key: "image_assets") {
            value
            type
            }
            bundleProducts : metafield(namespace: "custom", key: "bundle_products") {
            value
            type
            }
            family : metafield(namespace: "custom", key: "family") {
            value
            type
            }
            code : metafield(namespace: "custom", key: "code") {
            value
            type
            }
            familySequenceNumber : metafield(namespace: "custom", key: "family_sequence_number") {
            value
            type
            }
            serviceSummary : metafield(namespace: "custom", key: "service_summary") {
            value
            type
            }
            serviceName : metafield(namespace: "custom", key: "service_name") {
            value
            type
            }
            serviceOgDescription : metafield(namespace: "custom", key: "service_og_description") {
            value
            type
            }
            serviceOgTitle : metafield(namespace: "custom", key: "service_og_title") {
            value
            type
            }
            serviceMetaTitle : metafield(namespace: "custom", key: "service_meta_title") {
            value
            type
            }
            serviceMetaDescription : metafield(namespace: "custom", key: "service_meta_description") {
            value
            type
            }
            webOverview : metafield(namespace: "custom", key: "web_overview") {
            value
            type
            }
            htmlContent : metafield(namespace: "custom", key: "html_content") {
            value
            type
            }
            isBundle : metafield(namespace: "custom", key: "is_bundle") {
            value
            type
            }
            compatibilityApps : metafield(namespace: "custom", key: "compatibility_apps") {
            value
            type
            }
            

            # End Old SKU Metafields  
        }
      }
    }



    # New Product Metafields    
    productNumber: metafield(namespace: "product", key: "product_number") {
    value
    type
    }
    proWorksWithResideoApp: metafield(namespace: "product", key: "pro_works_with_resideo_app") {
    value
    type
    }
    proProductBreadcrumbName: metafield(namespace: "product", key: "pro_product_breadcrumb_name") {
    value
    type
    }
    worksWithResideoAppDescription: metafield(namespace: "product", key: "works_with_resideo_app_description") {
    value
    type
    }
    proProductShortDescription: metafield(namespace: "product", key: "pro_product_short_description") {
    value
    type
    }
    proProductWebOverview: metafield(namespace: "product", key: "pro_product_web_overview") {
    value
    type
    }
    proProductDetailPageTitle: metafield(namespace: "product", key: "pro_product_detail_page_title") {
    value
    type
    }
    proBrand: metafield(namespace: "product", key: "pro_brand") {
    value
    type
    }
    thermostatWiringCompatibility: metafield(namespace: "product", key: "thermostat_wiring_compatibility") {
    value
    type
    }
    worksWithResideoApp: metafield(namespace: "product", key: "works_with_resideo_app") {
    value
    type
    }
    websiteProductStatus: metafield(namespace: "product", key: "website_product_status") {
    value
    type
    }
    bestSellerBadge: metafield(namespace: "product", key: "best_seller_badge") {
    value
    type
    }
    webPreview: metafield(namespace: "product", key: "web_preview") {
    value
    type
    }
    compatibleThirdPartyApps: metafield(namespace: "product", key: "compatible_third_party_apps") {
    value
    type
    }
    compatibleWithThirdPartyApp: metafield(namespace: "product", key: "compatible_with_third_party_app") {
    value
    type
    }


    # End New Product Metafields  






    # Old Product Metafields  
    subscriptionCode: metafield(namespace: "custom", key: "subscription_code") {
    value
    type
    }
    soldIndividually: metafield(namespace: "custom", key: "sold_individually") {
    value
    type
    }

    resources: metafield(namespace: "custom", key: "resources") {
    value
    type
    }

    # End Old Product Metafields  
    
  }
}
`;

/**
 * Products listing query with basic metafields
 */
export const PRODUCTS_WITH_METAFIELDS_QUERY = `
query ProductsWithMetafields($first: Int!) {
  products(first: $first) {
    edges {
      node {
        id
        title
        description
        handle
        featuredImage {
          url
          altText
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        bestSellerBadge: metafield(namespace: "product", key: "best_seller_badge") {
          value
          type
        }
        websiteProductStatus: metafield(namespace: "product", key: "website_product_status") {
          value
          type
        }
      }
    }
  }
}
`;

/**
 * Collection query with metafields
 */
export const COLLECTION_WITH_METAFIELDS_QUERY = `
query CollectionWithMetafields($handle: String!) {
  collection(handle: $handle) {
    id
    title
    description
    handle
    code: metafield(namespace: "collection", key: "code") {
      value
      type
    }
    parentCode: metafield(namespace: "collection", key: "parent_code") {
      value
      type
    }
    products(first: 20) {
      edges {
        node {
          id
          title
          handle
          featuredImage {
            url
            altText
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
}
`;
